import { render, staticRenderFns } from "./customizationAuditorium.vue?vue&type=template&id=656a8ddb"
import script from "./customizationAuditorium.vue?vue&type=script&lang=js"
export * from "./customizationAuditorium.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports